import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { ReactComponent as QuoteOpen } from "../../../assets/images/quote-sx.svg";
import { ReactComponent as QuoteClose } from "../../../assets/images/quote-dx.svg";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";
import fotoDirigenti from "../../../assets/images/dirigenti-foto-cerchio.webp";
import firmaPres from "../../../assets/images/firma-pres.png";
import firmaGm from "../../../assets/images/firma-gm.png";
import bkg from "../../../assets/images/bkg-beige.png";

export default function Sezione2popup1({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  // ESC + blocco scroll quando il popup è aperto
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
  const url = new URL(window.location.href);
  url.searchParams.set("popup", popupId);

  if (navigator.share) {
    navigator
      .share({ title: "Lettera agli Stakeholder", url: url.toString() })
      .catch(() => {});
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(url.toString()).catch(() => {});
  }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[999] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Lettera agli stakeholder"
    >
      <div
        className="
          relative
          bg-white shadow-2xl
          max-h-[90vh] w-full md:w-[1280px] overflow-y-auto overscroll-contain
        "
        // sfondo
        style={{
             backgroundImage: `url(${bkg})`,
            backgroundRepeat:'no-repeat',
            backgroundPosition:'right bottom',
            backgroundSize:'cover'
        }}
      >
        {/* Azioni in alto a destra: badge, share, X */}
        <div className="absolute right-3 top-3 flex items-center gap-2 z-2">
          <button
            onClick={() => onShare("Sezione2popup1")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] hover:bg-[#fff] hover:text-white border border-transparent hover:border-[#0E3761] transition"
            title="Condividi"
            aria-label="Condividi"
          >
            {shareIcon ? <img src={shareIcon} alt="" className="h-4 w-4" /> : "↗"}
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] hover:bg-[#fff] hover:text-white border border-transparent hover:border-[#0E3761] transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            {closeIcon ? <img src={closeIcon} alt="Chiudi" className="h-4 w-4" /> : "✕"}
          </button>
        </div>

        {/* Contenuto */}
        <div className="py-8 px-5 md:px-8">

          {/* Immagine circolare flottante: il testo scorre attorno (shape-outside) */}
          <img
            src={fotoDirigenti}
            alt="Presidente e General Manager di Reale Group"
            className="mx-auto md:mx-0 md:float-left w-[240px] md:w-[440px] h-auto mb-5 md:mb-2 md:mr-10"
            style={{ shapeOutside: "circle(200px at 210px 210px)", shapeMargin: "30px", marginLeft: "-20px", marginTop: "-20px" }}
          />

          {/* Testo della lettera (scorre attorno al cerchio) */}
          <QuoteOpen className="w-6 h-6 inline-block align-top ml-0 md:ml-12 flex-shrink-0" />
          <p className="text-[16px] md:text-[24px] mt-4">
            
            Care lettrici, cari lettori,
          </p>
          <p className="text-[16px] md:text-[24px] mt-4">
            il Bilancio Consolidato Integrato che avete tra le mani racconta un anno denso: di risultati, ma anche di complessità. Il 2025 si è mosso su uno sfondo geopolitico e macroeconomico tutt’altro che semplice, eppure Reale Group ha saputo attraversarlo con solidità, confermando che un modello fondato sulla mutualità e sulla sostenibilità può generare valore durevole - per chi ne fa parte e per i territori in cui opera.
          </p>
          <p className="text-[16px] md:text-[24px] mt-4">
            Non è un risultato scontato. È il frutto del lavoro quotidiano delle nostre persone, di scelte strategiche portate avanti con coerenza e della fiducia che Soci, Clienti e Partner continuano a riporre nel Gruppo.
          </p>
          <p className="text-[16px] md:text-[24px] mt-4">
            La nostra identità di Mutua e la natura di Società Benefit sono i pilastri di ogni nostra azione. Abitare una “casa di tutti” significa mettere al centro il benessere degli individui e lo sviluppo dei territori, convinti che la mutualità sia un modello moderno capace di trasformare il valore generato in protezione condivisa. In questo solco, la sostenibilità è per noi un valore imprescindibile che rafforza il senso di appartenenza: abbiamo scelto di integrare l’impatto ESG come variabile determinante per le nostre strategie e decisioni, misurando il successo dell’impresa anche attraverso il beneficio tangibile creato per la collettività.
          </p>
          <p className="text-[16px] md:text-[24px] mt-4">
            Guardando al domani, vogliamo essere una presenza costante e rassicurante nella vita delle persone. L’evoluzione verso un ecosistema della salute, rafforzato da acquisizioni chiave come quella di Lifenet, ci permette di accompagnare Soci e Clienti dalla prevenzione alla cura passando per la protezione, sostenendo l’idea di una sanità intesa come bene comune e fondata sulla centralità della persona. Parallelamente, il nostro impegno nel mondo dell’abitare contribuisce concretamente alla transizione energetica; attraverso lo sviluppo di comunità energetiche e l’efficienza immobiliare, infatti, intendiamo proteggere l’ambiente e preservare la qualità della vita quotidiana anche delle generazioni future.
          </p>
          <p className="text-[16px] md:text-[24px] mt-4">
            L’innovazione tecnologica e l’intelligenza artificiale sono oggi potenti motori di questo cambiamento e trasformazione, che affrontiamo con un approccio etico per valorizzare il talento umano ed elevare i nostri standard. Mentre procediamo verso il traguardo dei duecento anni, la nostra ambizione è consolidare questa presenza portando i nostri valori anche verso nuovi mercati internazionali.
          </p>
          <p className="text-[16px] md:text-[24px] mt-4">
            Siamo pronti ad affrontare le evoluzioni del settore con la serenità che deriva dalla nostra forza patrimoniale e dallo spirito di squadra, continuando a dedicarci alla cura delle persone, fedeli al nostro Purpose: “Taking care of people for a better world, together”.
          </p>
          <p className="text-[16px] md:text-[24px] mt-4">
            Augurando a tutti noi un percorso di valore e crescita,
          </p>
          <p className="text-[16px] md:text-[24px] mt-4 flex items-end gap-2">
            <span>Buona lettura!</span>
            <QuoteClose className="w-6 h-6 flex-shrink-0" />
          </p>

          {/* fine del flusso attorno al cerchio */}
          <div className="clear-both" />

          {/* Firme */}
          <div className="mt-10 flex flex-col md:flex-row md:justify-between gap-8">
                <div className="flex flex-col items-start">
                  <div className="font-semibold text-[#0E3761]">Luigi Lana</div>
                  <div className="text-sm text-[#0E3761]">Presidente Reale Mutua</div>
                  <img
                    src={firmaPres}
                    alt="Firma Luigi Lana"
                    className="h-12 md:h-14 object-contain mt-2"
                  />
                </div>
                <div className="flex flex-col items-start md:items-end">
                  <div className="font-semibold text-[#0E3761]">Luca Filippone</div>
                  <div className="text-sm text-[#0E3761]">Group &amp; RMA General Manager</div>
                  <img
                    src={firmaGm}
                    alt="Firma Luca Filippone"
                    className="h-12 md:h-14 object-contain mt-2"
                  />
                </div>
              </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
